import Swal from 'sweetalert2';
import { get_token } from '@/router';

export default {
getToken() {
            return get_token();
        },
get_membership_dashboard_value(key,
fallback = 0) {
            const value = Reflect.get(this.membership_dashboard || {}, key);
            return [undefined, null, ''].includes(value) ? fallback : value;
        },
get_total_paid_users(membership_id) {
            return Reflect.get(this.total_paid_users || {}, membership_id) || 0;
        },
refresh_membership_dashboard_from_list() {
            const memberships = this.memberships || [];
            const membership_types = new Set();
            const billing_cycles = new Set();

            memberships.forEach((membership) => {
                const membership_type = membership?.membership_type?.name;
                const billing_cycle = membership?.billing_cycle?.name;

                if (membership_type) membership_types.add(String(membership_type));
                if (billing_cycle) billing_cycles.add(String(billing_cycle));
            });

            this.membership_dashboard = {
                ...this.membership_dashboard,
                total_count: memberships.length,
                active_count: memberships.filter(membership => membership?.is_active).length,
                inactive_count: memberships.filter(membership => !membership?.is_active).length,
                membership_type_count: membership_types.size,
                billing_cycle_count: billing_cycles.size,
            };
        },
is_membership_published(membership) {
            return Boolean(membership?.is_active);
        },
toggleSidebar() {
            if (!this.show_sidebar || !this.$refs.sidebar) return;
            this.$refs.sidebar.$el.classList.toggle("close");
        },
get_membership_types() {
            this.token_exists = get_token();

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_membership_types/`,
                method: "GET",
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    this.membership_types = response.data.membership_type;
                },
            });
        },
get_billing_cycle_choices() {
            this.token_exists = get_token();

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_billing_cycles/`,
                method: "GET",
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    this.billing_cycle_choices = response.data.billing_cycles;
                },
            });

        },
get_filtered_membership_types(query) {
            if (!query) return this.membership_types;

            const normalized_query = String(query).toLowerCase().trim();
            return this.membership_types.filter(type =>
                String(type.name).toLowerCase().includes(normalized_query)
            );
        },
get_membership_type_submission_value(value) {
            const normalized_value = String(value || '').trim().toLowerCase();
            if (!normalized_value) return '';

            const selected_type = this.membership_types.find(type =>
                String(type.name).trim().toLowerCase() === normalized_value
            );

            return selected_type ? selected_type.id : value;
        },
on_membership_type_input() {
            this.show_membership_type_dropdown = true;
        },
select_membership_type(type) {
            this.membership_type = type.name;
            this.show_membership_type_dropdown = false;
        },
open_create_membership_modal() {
            this.resetForm();
        },
submit_membership_form(publish_membership = false) {
            if (this.editing_membership_id) {
                this.updateMembership();
                return;
            }

            this.createMembership(publish_membership);
        },
createMembership(publish_membership = false) {
            if (!this.validateMembershipForm()) {
                return;
            }

            this.append_draft_membership_perk();
            if (publish_membership && !this.membership_has_publishable_perks()) {
                this.errors.membership_perks = 'Add at least one perk before publishing, or save this membership as a draft.';
                return;
            }
            this.show_membership_submit_loading(publish_membership);
            this.isSubmitting = true;
            this.membership_submit_action = publish_membership ? 'publish' : 'draft';

            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_membership/`,
                data: JSON.stringify(this.build_membership_payload(publish_membership)),
                processData: false,
                contentType: 'application/json',
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                },
                success: (response) => this.handle_create_membership_success(response, publish_membership),
                error: (response) => this.handle_create_membership_error(response),
                complete: () => {
                    this.isSubmitting = false;
                    this.membership_submit_action = '';
                },
            });
        },
membership_has_publishable_perks() {
            return this.membership_perks.some(perk =>
                this.build_membership_perk_payload_item(perk)
            );
        },
show_membership_submit_loading(publish_membership = false) {
            Swal.fire({
                title: publish_membership ? 'Publishing...' : 'Saving draft...',
                text: 'Please wait while we process your request.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        },
build_membership_payload(publish_membership = false) {
            const membership_perks = this.membership_perks
                .map(this.build_membership_perk_payload_item)
                .filter(perk => perk);

            return ({
                description: this.membership_description,
                membership_type: this.get_membership_type_submission_value(this.membership_type),
                price: this.membership_price,
                billing_cycle: this.billing_cycle,
                is_active: Boolean(publish_membership),
                perks: membership_perks.map(perk => perk.name),
                membership_perks,
            });
        },
handle_create_membership_success(response, publish_membership = false) {
            if (response.status !== "success") return;

            const new_membership = response.data;
            if (new_membership) {
                this.memberships.unshift(new_membership);
                this.refresh_membership_dashboard_from_list();
            }
            if (publish_membership && new_membership && !new_membership.is_active) {
                this.publish_created_membership(new_membership);
                return;
            }
            this.finish_create_membership(publish_membership);
        },
publish_created_membership(membership) {
            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/toggle_membership_status/`,
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify({
                    membership_id: membership.id,
                    is_active: true,
                }),
                success: (response) => {
                    if (response.status === 'success') {
                        membership.is_active = true;
                        this.refresh_membership_dashboard_from_list();
                        this.finish_create_membership(true);
                        return;
                    }

                    this.handle_publish_created_membership_error(response);
                },
                error: (response) => this.handle_publish_created_membership_error(response),
            });
        },
handle_publish_created_membership_error(response) {
            const response_data = response.responseJSON || response;
            const message = response_data?.message || 'Membership was saved as a draft, but publishing failed.';

            Swal.fire({
                icon: 'warning',
                title: 'Saved as draft',
                text: message,
                showConfirmButton: true,
            }).then(() => {
                this.resetForm();
                $('#create_membership').modal('hide');
            });
        },
finish_create_membership(publish_membership = false) {
            Swal.fire({
                icon: "success",
                title: publish_membership ? "Membership published" : "Draft saved",
                showConfirmButton: false,
                timer: 1000,
                position: 'bottom-end',
                toast: true
            }).then(() => {
                this.resetForm();
                $('#create_membership').modal('hide');
            });
        },
handle_create_membership_error(response) {
            Swal.close();
            const response_data = response.responseJSON;
            if (response_data) {
                this.errors = response_data;
            }
        }
};

